var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_74_411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6798 6.68003L11.5498 6.09003L11.2298 6.60003L11.0698 6.85003L11.8198 10.08L12.2898 9.32003L11.6798 6.68003Z",
    fill: "#3D63A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.34 4.81L11.75 5.76L12 6.85L12.5 9L12.92 8.32L13.09 8.05L12.34 4.81Z",
    fill: "#3D63A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5.76001L11.55 6.09001L11.68 6.68001L12.29 9.32001L12.5 9.00001L12 6.85001L11.75 5.76001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93994 8.66999C9.93994 8.77999 9.95994 8.89999 9.98994 9.00999C10.1699 9.95999 10.7599 10.68 11.4099 10.85L11.8699 10.11L11.0999 6.79999L9.93994 8.65999V8.66999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.96002 4.84C3.96002 4.84 3.36002 1.43 5.99002 1.43C8.62002 1.43 10.17 1.43 9.92002 0C9.92002 0 11.88 1.84 10.92 4.84C9.96002 7.84 3.96002 4.84 3.96002 4.84Z",
    fill: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.17 6.74997C14.47 4.11997 11.06 2.90997 11.06 2.90997C11.49 4.54997 9.82003 3.99997 5.26003 3.99997C0.70003 3.99997 1.73003 7.58997 1.74003 7.88997C2.09003 7.64997 2.54003 7.46997 3.12003 7.34997C6.80003 6.59997 13.08 9.72997 14.17 6.74997Z",
    fill: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.17 6.73999C14.13 7.09999 14.02 7.48999 13.82 7.90999C12.16 11.36 1.73997 7.90999 1.73997 7.90999C1.73997 7.90999 1.73997 7.90999 1.73997 7.88999C-0.0900302 9.13999 1.03997 11.67 1.03997 11.67C1.03997 11.67 11.35 13.86 14.27 12.26C17.19 10.67 14.18 6.73999 14.18 6.73999H14.17Z",
    fill: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73999 7.90999C1.73999 7.90999 12.16 11.36 13.82 7.90999C14.02 7.48999 14.13 7.09999 14.17 6.73999C13.08 9.71999 6.79999 6.59999 3.11999 7.33999C2.53999 7.45999 2.08999 7.64999 1.73999 7.87999C1.73999 7.88999 1.73999 7.89999 1.73999 7.89999V7.90999Z",
    fill: "#FF868B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92993 4.15997C3.92993 4.15997 4.28993 3.97997 5.16993 4.15997C6.04993 4.33997 11.7299 5.70997 12.3499 4.75997C12.9799 3.80997 11.2999 2.92997 11.1799 2.95997C11.1799 2.95997 11.4999 3.93997 9.36993 3.89997C7.23993 3.85997 5.39993 3.74997 3.92993 4.16997V4.15997Z",
    fill: "#FF868B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21012 11.07C8.21012 11.07 8.18012 11.07 8.16012 11.07C8.14012 11.07 8.13012 11.07 8.12012 11.07L8.16012 11.12L8.21012 11.07Z",
    fill: "#FF3EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.98 9.82001L12.64 11.11L12.59 11.48L11.72 17.75C12.04 17.7 12.36 17.64 12.66 17.58L13.65 11.73L13.97 9.82001H13.98Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3999 11.17L9.86987 17.95C10.1799 17.93 10.4899 17.9 10.7899 17.87L11.4999 11.3L11.6599 9.83002L10.3999 11.12V11.17Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1698 11.11L8.0498 18C8.0498 18 8.1298 18 8.1698 18C8.4398 18 8.6998 18 8.9698 17.99L9.2998 11.09L9.3598 9.82001L8.2198 11.06L8.1698 11.11Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.34989 9.82001L1.38989 11.12L1.54989 12.09L2.42989 17.28C2.73989 17.37 3.06989 17.45 3.40989 17.53L2.61989 11.76L2.34989 9.83001V9.82001Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8699 11.11L14.6799 12.05L13.6199 17.35C13.9699 17.26 14.2999 17.15 14.6099 17.04L15.6599 12.47L16.2699 9.82001L14.8599 11.11H14.8699Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02992 9.82001L5.91992 11.12V11.17L6.22992 17.93C6.52992 17.95 6.83992 17.97 7.14992 17.98L7.04992 11.09L7.02992 9.82001Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68991 9.82001L3.65991 11.12L3.69991 11.49L4.35991 17.71C4.65991 17.76 4.97991 17.81 5.29991 17.84L4.79991 11.3L4.68991 9.82001Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.39 11.12L0 9.82001L0.54 12.54L1.42 16.94C1.73 17.06 2.07 17.18 2.43 17.28L1.55 12.09L1.39 11.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.6601 11.12L2.3501 9.82001L2.6201 11.75L3.4101 17.52C3.7201 17.59 4.0301 17.65 4.3601 17.7L3.7001 11.48L3.6601 11.11V11.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91995 11.12L4.69995 9.82001L4.80995 11.3L5.30995 17.84C5.60995 17.88 5.91995 17.91 6.22995 17.93L5.92995 11.17V11.12H5.91995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03003 9.82001L7.05003 11.09L7.15003 17.98C7.45003 17.99 7.75003 18 8.06003 18L8.18003 11.11L8.14003 11.06L7.04003 9.82001H7.03003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28996 11.09L8.95996 17.99C9.26996 17.99 9.56996 17.96 9.86996 17.94L10.4 11.16V11.11L9.34996 9.82001L9.28996 11.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.51 11.29L10.8 17.86C11.12 17.83 11.42 17.79 11.73 17.74L12.6 11.47L12.65 11.1L11.68 9.81L11.52 11.28L11.51 11.29Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9799 9.82001L13.6599 11.73L12.6699 17.58C12.9999 17.51 13.3199 17.44 13.6299 17.35L14.6899 12.05L14.8799 11.11L13.9899 9.82001H13.9799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1 1.76997C6.1 2.20997 5.74 2.56997 5.3 2.56997C4.86 2.56997 4.5 2.20997 4.5 1.76997C4.5 1.32997 4.86 0.969971 5.3 0.969971C5.74 0.969971 6.1 1.32997 6.1 1.76997Z",
    fill: "#72342E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67011 1.92994C4.67011 1.92994 4.61011 1.89994 4.61011 1.86994C4.61011 1.63994 4.68011 1.45994 4.81011 1.32994C5.02011 1.12994 5.31011 1.12994 5.32011 1.12994C5.35011 1.12994 5.38011 1.15994 5.38011 1.18994C5.38011 1.21994 5.35011 1.24994 5.32011 1.24994C5.32011 1.24994 5.07011 1.24994 4.90011 1.40994C4.79011 1.50994 4.74011 1.66994 4.74011 1.85994C4.74011 1.88994 4.71011 1.91994 4.68011 1.91994L4.67011 1.92994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.71005 1.29997C5.71005 1.29997 5.67005 1.37997 5.63005 1.37997C5.59005 1.37997 5.55005 1.33997 5.55005 1.29997C5.55005 1.25997 5.59005 1.21997 5.63005 1.21997C5.67005 1.21997 5.71005 1.25997 5.71005 1.29997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66006 6.74C3.66006 7.18 3.30006 7.54 2.86006 7.54C2.42006 7.54 2.06006 7.18 2.06006 6.74C2.06006 6.3 2.42006 5.94 2.86006 5.94C3.30006 5.94 3.66006 6.3 3.66006 6.74Z",
    fill: "#72342E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.23017 6.89998C2.23017 6.89998 2.17017 6.86998 2.17017 6.83998C2.17017 6.60998 2.24017 6.42998 2.37017 6.29998C2.58017 6.09998 2.87017 6.09998 2.88017 6.09998C2.92017 6.09998 2.94017 6.12998 2.94017 6.15998C2.94017 6.18998 2.91017 6.21998 2.88017 6.21998C2.88017 6.21998 2.63017 6.21998 2.46017 6.37998C2.35017 6.47998 2.30017 6.63998 2.30017 6.82998C2.30017 6.86998 2.27017 6.88998 2.24017 6.88998L2.23017 6.89998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27011 6.27C3.27011 6.27 3.23011 6.35 3.19011 6.35C3.15011 6.35 3.11011 6.31 3.11011 6.27C3.11011 6.23 3.15011 6.19 3.19011 6.19C3.23011 6.19 3.27011 6.23 3.27011 6.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1901 2.09999C11.1901 2.53999 10.8301 2.89999 10.3901 2.89999C9.95009 2.89999 9.59009 2.53999 9.59009 2.09999C9.59009 1.65999 9.95009 1.29999 10.3901 1.29999C10.8301 1.29999 11.1901 1.65999 11.1901 2.09999Z",
    fill: "#72342E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7602 2.25996C9.7602 2.25996 9.7002 2.22996 9.7002 2.19996C9.7002 1.96996 9.7702 1.78996 9.9002 1.65996C10.1102 1.45996 10.4002 1.45996 10.4102 1.45996C10.4402 1.45996 10.4702 1.48996 10.4702 1.51996C10.4702 1.54996 10.4402 1.57996 10.4102 1.57996C10.4102 1.57996 10.1602 1.57996 9.9902 1.73996C9.8802 1.83996 9.8302 1.99996 9.8302 2.18996C9.8302 2.21996 9.8002 2.24996 9.7702 2.24996L9.7602 2.25996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7901 1.62999C10.7901 1.62999 10.7501 1.70999 10.7101 1.70999C10.6701 1.70999 10.6301 1.66999 10.6301 1.62999C10.6301 1.58999 10.6701 1.54999 10.7101 1.54999C10.7501 1.54999 10.7901 1.58999 10.7901 1.62999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23989 8.33998C9.23989 8.77998 8.87989 9.13998 8.43989 9.13998C7.99989 9.13998 7.63989 8.77998 7.63989 8.33998C7.63989 7.89998 7.99989 7.53998 8.43989 7.53998C8.87989 7.53998 9.23989 7.89998 9.23989 8.33998Z",
    fill: "#72342E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.81 8.49995C7.81 8.49995 7.75 8.46995 7.75 8.43995C7.75 8.20995 7.82 8.02995 7.95 7.89995C8.16 7.69995 8.45 7.69995 8.46 7.69995C8.5 7.69995 8.52 7.72995 8.52 7.75995C8.52 7.78995 8.49 7.81995 8.46 7.81995C8.46 7.81995 8.21 7.81995 8.04 7.97995C7.93 8.07995 7.88 8.23995 7.88 8.42995C7.88 8.46995 7.85 8.48995 7.82 8.48995L7.81 8.49995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.83993 7.86998C8.83993 7.86998 8.79993 7.94998 8.75993 7.94998C8.71993 7.94998 8.67993 7.90998 8.67993 7.86998C8.67993 7.82998 8.71993 7.78998 8.75993 7.78998C8.79993 7.78998 8.83993 7.82998 8.83993 7.86998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.59 6.08998C13.59 6.52998 13.23 6.88998 12.79 6.88998C12.35 6.88998 11.99 6.52998 11.99 6.08998C11.99 5.64998 12.35 5.28998 12.79 5.28998C13.23 5.28998 13.59 5.64998 13.59 6.08998Z",
    fill: "#72342E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1701 6.24995C12.1701 6.24995 12.1101 6.21995 12.1101 6.18995C12.1101 5.95995 12.1801 5.77995 12.3101 5.64995C12.5201 5.44995 12.8101 5.44995 12.8201 5.44995C12.8501 5.44995 12.8801 5.47995 12.8801 5.50995C12.8801 5.53995 12.8501 5.56995 12.8201 5.56995C12.8201 5.56995 12.5701 5.56995 12.4001 5.72995C12.2901 5.82995 12.2401 5.98995 12.2401 6.17995C12.2401 6.20995 12.2101 6.23995 12.1801 6.23995L12.1701 6.24995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 5.61998C13.2 5.61998 13.16 5.69998 13.12 5.69998C13.08 5.69998 13.04 5.65998 13.04 5.61998C13.04 5.57998 13.08 5.53998 13.12 5.53998C13.16 5.53998 13.2 5.57998 13.2 5.61998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_74_411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.28,
    height: 18.01,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventIcon);
export default __webpack_public_path__ + "static/media/eventIcon.ca7edacee2d5af7f8c39bab65dd78238.svg";
export { ForwardRef as ReactComponent };